type LoaderProps = {
  text?: string;
};
export const Loader = ({ text = "" }: LoaderProps) => {
  return (
    <div className="flex flex-col items-center space-y-6">
      <div className="animate-spin rounded-full border-4 border-gray-300 border-t-gray-900 h-24 w-24" />
      {text ? <p className="text-gray-500 dark:text-gray-400 mt-8">{text}</p> : null}
    </div>
  );
};
